<template>
  <div>
    <el-table
      :data="userList"
      size="mini"
      style="width: 100%"
      height="calc(100vh - 353px)"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="仓位类型" align="center" min-width="100"><template slot-scope="scope">{{ formatPositionCategory(scope.row) }}</template></el-table-column>
      <el-table-column
        label="委托订单ID"
        min-width="170"
        align="left"
        fixed="left"
      >
        <template slot-scope="scope">
          {{ scope.row.orderId }}
          <!-- <div class="order">
            <img
              :src="order"
              alt=""
              @mouseover="isShow = true"
              @mouseleave="isShow = false"
              class="pointer"
            />
            <div class="tip_box">
              <span> {{ scope.row.orderId }}</span>
              <img :src="copy" alt="" />
              <img :src="tip" alt="" />
            </div>
          </div> -->
          <!-- <el-popover
            trigger="hover"
            placement="top-start"
            popper-class="tip_box"
          >
            <img :src="order" slot="reference" alt="" class="pointer" />
            <div class="tip_box_item">
              {{ scope.row.orderId }}
              <img :src="copy" alt="" @click="handleCopy(scope.row.orderId)" />
            </div>
          </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column
        label="仓位ID"
        align="center"
        prop="positionId"
        fixed="left"
        width="160"
      />

      <el-table-column
        prop="userId"
        label="用户UID"
        align="center"
        fixed="left"
        min-width="160"
      >
        <template slot-scope="scope">
          <span
            @click="showBox(scope.row, 2)"
            :class="{
              tdRed: scope.row.mark == true,
              blue: scope.row.mark != true,
              myTd: true,
            }"
            >{{ scope.row.userId }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="userTypeName"
        label="用户类型"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="channelUserId"
        label="合伙人UID"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="userType" label="用户身份">
        <template slot-scope="scope">
          <span v-if="scope.row.userType == '普通用户'" class="red">{{
            scope.row.userType
          }}</span>
          <span v-else class="cc">{{ scope.row.userType }}</span>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="symbol"
        label="合约名称"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.symbol }}
        </template>
      </el-table-column>
      <el-table-column label="方向" align="center" min-width="100">
        <template slot-scope="scope">
          <span
            v-if="scope.row.orderSide == 1"
            :style="{
              color: '#03ad79',
            }"
            >买入{{ scope.row.positionSide == 1 ? "开多" : "平空" }}</span
          >
          <span
            v-if="scope.row.orderSide == 2"
            :style="{
              color: ' #EC6D56',
            }"
            >卖出{{ scope.row.positionSide == 1 ? "平多" : "开空" }}</span
          >
        </template>
      </el-table-column>
      <!-- <el-table-column prop="channelUserId" label="杠杆" align="center">
        <template slot-scope="scope">
      
          <span>100X</span>
        </template>
      </el-table-column> -->
      <el-table-column label="委托价格(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span
            >{{ scope.row.price }}
            {{ scope.row.symbol.split("_")[1].toUpperCase() }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="委托数量"
        width="120"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="成交数量(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span
            >{{ scope.row.dealAmount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="成交均价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span
            >{{ scope.row.averagePrice }}
          </span>
        </template>
      </el-table-column> -->

      <el-table-column label="类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.orderType == 1">限价委托</span>
          <span v-if="scope.row.orderType == 2">市价委托</span>
          <span v-if="scope.row.orderType == 3">爆仓</span>
        </template>
      </el-table-column>
      <el-table-column label="止盈价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.triggerProfitPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="止损价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.triggerStopPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="委托时间" align="right" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="goDetail(scope.row)">资产明细</el-button>
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)" v-if="scope.row.type==0"
            >修改备注</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add"
              >添 加</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import order from "@/assets/order.png";
import copy from "@/assets/copy.png";
import tip from "@/assets/partnerCenter/tip.png";
import UserDetailDialog from "components/userDetailDialog";
import { formatPositionCategory } from "../../../positionCategory";

export default {
  name: "UserList",
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: "",
      order,
      copy,
      tip,
      isShow: false,
      type: "",
      id: "",
    };
  },
  components: {
    Pagination,
    updateDialog,
    UserDetailDialog,
  },
  methods: {
    formatPositionCategory,
    ...mapActions("currentDelegation", ["addRemark"]),
    ...mapMutations("currentDelegation", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapMutations("contractassets", ["setUserDetailInfoVisible"]),

    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(row) {
      this.updateForm = row;
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true;
      this.textarea2 = row.remarks;
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          (this.textarea2 = ""), (this.centerDialogVisible = false);
          this.$emit("refresh");
        }
      });
    },
    goDetail(row) {
      this.$router.push({ path: `/home/currentDelegation/detail`, query: row });
    },

    handleCopy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
        center: true,
      });
      oInput.remove();
    },
    showBox(row, type) {
      this.type = type;
      this.id = type == 2 ? row.userId : row.channelUserId;
      this.setUserDetailInfoVisible(true);
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return "redRow";
      }
      return "";
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(["userInfo"]),
    ...mapState("currentDelegation", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../../styles/table.less" scoped>
::v-deep.el-table__fixed-right::before {
  background-color: transparent !important ;
}
</style>
<style lang="less" scoped>
.order {
  position: relative;
  .tip_box {
    position: absolute;
    top: -20px;
    right: 0;
    z-index: 99;
  }
}
</style>
